module.exports = __webpack_public_path__ + "static/media/Purple_Chat_Bubble.188686eb.png";